import React, { lazy, memo, Suspense } from "react";

import PropTypes from "prop-types";

import useLanguage from "../../hooks/useLanguage";
import { startCase } from "../../utils/stringUtilHelper";

import "./logo.scss";

const DkmsLogoEn = lazy(() => (
  import("../../images/logo/a-logo-dkms-en.svg").then((module) => ({ default: module.ReactComponent }))
));

const DkmsLogoEnWhite = lazy(() => (
  import("../../images/logo/a-logo-dkms-en-white.svg").then((module) => ({ default: module.ReactComponent }))
));

const DkmsLogoNoTagline = lazy(() => (
  import("../../images/logo/a-logo-dkms-notagline.svg").then((module) => ({ default: module.ReactComponent }))
));

const DkmsLogoNoTaglineWhite = lazy(() => (
  import("../../images/logo/a-logo-dkms-notagline-white.svg").then((module) => ({ default: module.ReactComponent }))
));

const DkmsLogoDe = lazy(() => (
  import("../../images/logo/a-logo-dkms-de.svg").then((module) => ({ default: module.ReactComponent }))
));

const DkmsLogoDeWhite = lazy(() => (
  import("../../images/logo/a-logo-dkms-de-white.svg").then((module) => ({ default: module.ReactComponent }))
));

const DkmsLogoPl = lazy(() => (
  import("../../images/logo/a-logo-dkms-pl.svg").then((module) => ({ default: module.ReactComponent }))
));

const DkmsLogoPlWhite = lazy(() => (
  import("../../images/logo/a-logo-dkms-pl-white.svg").then((module) => ({ default: module.ReactComponent }))
));

const DkmsLogoEs = lazy(() => (
  import("../../images/logo/a-logo-dkms-es.svg").then((module) => ({ default: module.ReactComponent }))
));

const DkmsLogoEsWhite = lazy(() => (
  import("../../images/logo/a-logo-dkms-es-white.svg").then((module) => ({ default: module.ReactComponent }))
));

const Logo = ({ country = null, breakpoint, white = false }) => {
  const { countryCode } = useLanguage();
  const logoLanguage = country || countryCode;
  const color = white ? "White" : "";

  /* eslint-disable sort-keys */
  const logos = {
    dkmsLogoEn: DkmsLogoEn,
    dkmsLogoEnWhite: DkmsLogoEnWhite,
    dkmsLogoDe: DkmsLogoDe,
    dkmsLogoDeWhite: DkmsLogoDeWhite,
    dkmsLogoNoTagline: DkmsLogoNoTagline,
    dkmsLogoNoTaglineWhite: DkmsLogoNoTaglineWhite,
    dkmsLogoCl: DkmsLogoEs,
    dkmsLogoClWhite: DkmsLogoEsWhite,
    dkmsLogoPl: DkmsLogoPl,
    dkmsLogoPlWhite: DkmsLogoPlWhite,
  };

  let UsedLogo;
  const UsedLogoNoTagline = logos[`dkmsLogoNoTagline${color}`];

  switch (logoLanguage) {
    case "us":
    case "gb":
    case "za":
    case "in":
      UsedLogo = logos[`dkmsLogoEn${color}`];
      break;
    default: UsedLogo = logos[`dkmsLogo${startCase(logoLanguage)}${color}`];
  }

  return (
    <Suspense fallback={<div />}>
      <UsedLogo className={`logo d-none d-${breakpoint}-inline`} />
      <UsedLogoNoTagline className={`logo d-${breakpoint}-none`} />
    </Suspense>
  );
};

Logo.propTypes = {
  breakpoint: PropTypes.oneOf(["xs", "sm", "md", "lg"]).isRequired,
  country: PropTypes.string,
  white: PropTypes.bool,
};

export default memo(Logo);
